import { apurar, dataCivil, type Centavos, type Competencia } from "@ida/core";

export interface ImovelDiagnostico {
  recebido: Centavos;
  iptu: Centavos;
  condominio: Centavos;
  administracao: Centavos;
  outras: Centavos;
}

export const novoImovelDiagnostico = (): ImovelDiagnostico => ({
  recebido: 0, iptu: 0, condominio: 0, administracao: 0, outras: 0,
});
export const despesasDiagnostico = (i: ImovelDiagnostico) =>
  i.iptu + i.condominio + i.administracao + i.outras;
export const imovelDiagnosticoValido = (i: ImovelDiagnostico) =>
  Object.values(i).every((v) => Number.isSafeInteger(v) && v >= 0)
  && despesasDiagnostico(i) <= i.recebido;

export function calcularDiagnostico(imoveis: ImovelDiagnostico[], comp: Competencia, dependentes: number) {
  if (!imoveis.every(imovelDiagnosticoValido)) throw new Error("Revise as despesas dos imóveis.");
  return apurar({
    competencia: comp,
    recebimentos: imoveis.map((i, indice) => ({
      imovelId: `imovel-${indice}`, pagadorDocumento: "", pagadorNome: `Imóvel ${indice + 1}`,
      pagadorTipo: "PF" as const, valorRecebido: i.recebido,
      dataRecebimento: dataCivil(comp.ano, comp.mes, 5),
    })),
    deducoes: {
      iptu: imoveis.reduce((s, i) => s + i.iptu, 0),
      condominio: imoveis.reduce((s, i) => s + i.condominio, 0),
      taxaAdministracao: imoveis.reduce((s, i) => s + i.administracao, 0),
      despesasCobranca: imoveis.reduce((s, i) => s + i.outras, 0),
    },
    dependentes,
  });
}
